import React, { useState, useRef } from 'react';
import * as XLSX from 'xlsx';

const CardPrintComponent = () => {
  const [attendees, setAttendees] = useState([]);
  const [selectedMeeting, setSelectedMeeting] = useState({ name: 'CONFERENCE' });
  const fileInputRef = useRef(null);

  // Handle Excel file upload
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      // Assuming first row is header, extract name and type
      const extractedAttendees = jsonData
        .slice(1) // Skip header row
        .filter(row => row[0] && row[1]) // Only rows with both name and type
        .map((row, index) => ({
          id: index + 1,
          name: String(row[0]).trim().toUpperCase(),
          type: String(row[1]).trim().toUpperCase(),
          branch: 'MAIN' // Default branch as per your requirement
        }));

      setAttendees(extractedAttendees);
    };

    reader.readAsArrayBuffer(file);
  };

  // Your exact print function
  const printCard = (attendee) => {
    if (!selectedMeeting || !attendee) return;

    const printWindow = window.open('', '_blank');

    // Card dimensions in millimeters (111mm × 155mm)
    const cardWidth = 111;
    const cardHeight = 155;

    // Exact measurements from your card - adjusted slightly lower
    const vacantAreaTop = 85.0; // mm - moved slightly lower
    const vacantAreaHeight = 21.8; // mm (2.28cm height)

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Print Card</title>
        <style>
          /* PRINT STYLES ONLY */
          @media print {
            @page {
              size: ${cardWidth}mm ${cardHeight}mm;
              margin: 0;
              padding: 0;
            }
            
            html, body {
              width: ${cardWidth}mm;
              height: ${cardHeight}mm;
              margin: 0;
              padding: 0;
              background: transparent;
            }
            
            .print-container {
              position: relative;
              width: ${cardWidth}mm;
              height: ${cardHeight}mm;
            }
            
            .print-area {
              position: absolute;
              top: ${vacantAreaTop}mm;
              left: 0;
              width: ${cardWidth}mm;
              height: ${vacantAreaHeight}mm;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: flex-start;
              text-align: center;
              padding: 0 5mm;
              box-sizing: border-box;
            }
            
            .attendee-name {
              font-size: 14pt;
              font-weight: 900;
              color: #000000;
              margin: 0;
              padding: 0;
              text-transform: uppercase;
              letter-spacing: 0.2mm;
              line-height: 0.9;
              height: 7.5mm;
              display: flex;
              align-items: center;
              justify-content: center;
              font-family: 'Arial Black', sans-serif;
              text-shadow: none;
              -webkit-text-stroke: 0;
            }
            
            .attendee-type {
              font-size: 11.5pt;
              font-weight: 900;
              color: #000000;
              margin: -0.2mm 0 0 0;
              padding: 0;
              text-transform: uppercase;
              letter-spacing: 0.15mm;
              line-height: 0.9;
              height: 6.2mm;
              display: flex;
              align-items: center;
              justify-content: center;
              font-family: 'Arial Black', sans-serif;
            }
            
            .attendee-branch {
              font-size: 8.5pt;
              font-weight: 900;
              color: #000000;
              margin: -0.2mm 0 0 0;
              padding: 0;
              text-transform: uppercase;
              letter-spacing: 0.15mm;
              line-height: 0.9;
              height: 5.5mm;
              display: flex;
              align-items: center;
              justify-content: center;
              font-family: 'Arial Black', sans-serif;
            }
            
            /* HIDE EVERYTHING WHEN PRINTING */
            .no-print, .no-print * {
              display: none !important;
              visibility: hidden !important;
            }
          }
          
          /* SCREEN PREVIEW STYLES */
          @media screen {
            body {
              margin: 0;
              padding: 20px;
              background: #f0f0f0;
              display: flex;
              justify-content: center;
              align-items: flex-start;
              min-height: 100vh;
            }
            
            .print-container {
              width: ${cardWidth}mm;
              height: ${cardHeight}mm;
              background: white;
              position: relative;
              border: 1px solid #ccc;
              box-shadow: 0 0 10px rgba(0,0,0,0.1);
              transform: scale(0.8);
              transform-origin: top center;
            }
            
            .print-area {
              position: absolute;
              top: ${vacantAreaTop}mm;
              left: 0;
              width: ${cardWidth}mm;
              height: ${vacantAreaHeight}mm;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: flex-start;
              text-align: center;
              padding: 0 5mm;
              box-sizing: border-box;
              border: 1px dashed red;
              background: rgba(255,0,0,0.05);
            }
            
            .attendee-name {
              font-size: 12pt;
              font-weight: 900;
              color: #000000;
              margin: 0;
              padding: 0;
              text-transform: uppercase;
              letter-spacing: 0.2mm;
              line-height: 0.9;
              height: 7.5mm;
              display: flex;
              align-items: center;
              justify-content: center;
              font-family: 'Arial Black', sans-serif;
            }
            
            .attendee-type {
              font-size: 9.5pt;
              font-weight: 900;
              color: #000000;
              margin: -0.2mm 0 0 0;
              padding: 0;
              text-transform: uppercase;
              letter-spacing: 0.15mm;
              line-height: 0.9;
              height: 6.2mm;
              display: flex;
              align-items: center;
              justify-content: center;
              font-family: 'Arial Black', sans-serif;
            }
            
            .attendee-branch {
              font-size: 8.5pt;
              font-weight: 900;
              color: #000000;
              margin: -0.2mm 0 0 0;
              padding: 0;
              text-transform: uppercase;
              letter-spacing: 0.15mm;
              line-height: 0.9;
              height: 5.5mm;
              display: flex;
              align-items: center;
              justify-content: center;
              font-family: 'Arial Black', sans-serif;
            }
            
            .preview-guide {
              position: fixed;
              top: 10px;
              left: 10px;
              background: rgba(0,0,0,0.8);
              color: white;
              padding: 10px;
              font-size: 12px;
              border-radius: 5px;
              z-index: 1000;
            }
          }
        </style>
      </head>
      <body>
        <!-- Preview guide - only shows on screen, hidden when printing -->
        <div class="no-print preview-guide">
          PREVIEW: Card ${cardWidth}mm × ${cardHeight}mm | Print area starts at ${vacantAreaTop}mm (${vacantAreaHeight}mm height)
        </div>
        
        <div class="print-container">
          <div class="print-area">
            <div class="attendee-name">${attendee.name || 'GUEST'}</div>
            <div class="attendee-type">${attendee.type || 'ATTENDEE'}</div>
          </div>
        </div>
        
        <script>
          window.onload = function() {
            // Auto print after a short delay
            setTimeout(function() {
              window.print();
            }, 500);
            
            // Close window after printing
            window.onafterprint = function() {
              window.close();
            };
          }
        </script>
      </body>
      </html>
    `);
    printWindow.document.close();
  };

  // Print all cards
  const printAllCards = () => {
    attendees.forEach((attendee, index) => {
      setTimeout(() => {
        printCard(attendee);
      }, index * 1000); // 1 second delay between each print
    });
  };

  // Clear all data
  const clearData = () => {
    setAttendees([]);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  // Download sample Excel template
  const downloadTemplate = () => {
    const templateData = [
      ['Name', 'Type'],
      ['JOHN DOE', 'VIP'],
      ['JANE SMITH', 'SPEAKER'],
      ['BOB JOHNSON', 'DELEGATE']
    ];
    
    const ws = XLSX.utils.aoa_to_sheet(templateData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Attendees');
    XLSX.writeFile(wb, 'card_print_template.xlsx');
  };

  return (
    <div className="card-print-container">
      <div className="upload-section">
        <h2>Upload Attendee Excel Sheet</h2>
        <div className="instructions">
          <p>Upload an Excel file with two columns: Name and Type</p>
          <p>First row should be headers, data starts from second row</p>
        </div>
        
        <div className="upload-controls">
          <input
            type="file"
            accept=".xlsx, .xls, .csv"
            onChange={handleFileUpload}
            ref={fileInputRef}
            className="file-input"
          />
          
          <div className="action-buttons">
            <button 
              onClick={downloadTemplate}
              className="btn btn-secondary"
            >
              Download Template
            </button>
            
            {attendees.length > 0 && (
              <button 
                onClick={clearData}
                className="btn btn-danger"
              >
                Clear Data
              </button>
            )}
          </div>
        </div>
        
        {attendees.length > 0 && (
          <div className="summary">
            <p>Loaded {attendees.length} attendees</p>
            <button 
              onClick={printAllCards}
              className="btn btn-primary print-all-btn"
            >
              Print All Cards
            </button>
          </div>
        )}
      </div>

      {attendees.length > 0 && (
        <div className="attendees-list">
          <h3>Attendees List ({attendees.length} total)</h3>
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Type</th>
                  <th>Print</th>
                </tr>
              </thead>
              <tbody>
                {attendees.map((attendee) => (
                  <tr key={attendee.id}>
                    <td>{attendee.id}</td>
                    <td className="attendee-name-cell">{attendee.name}</td>
                    <td className="attendee-type-cell">{attendee.type}</td>
                    <td>
                      <button 
                        onClick={() => printCard(attendee)}
                        className="btn-print"
                      >
                        Print Card
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <style jsx>{`
        .card-print-container {
          padding: 20px;
          max-width: 1200px;
          margin: 0 auto;
          font-family: Arial, sans-serif;
        }
        
        .upload-section {
          background: #f8f9fa;
          padding: 20px;
          border-radius: 8px;
          margin-bottom: 30px;
          border: 1px solid #dee2e6;
        }
        
        h2 {
          color: #333;
          margin-bottom: 10px;
        }
        
        .instructions {
          background: #e9ecef;
          padding: 10px 15px;
          border-radius: 5px;
          margin-bottom: 20px;
          font-size: 14px;
        }
        
        .instructions p {
          margin: 5px 0;
        }
        
        .upload-controls {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }
        
        .file-input {
          padding: 10px;
          border: 2px dashed #007bff;
          border-radius: 5px;
          cursor: pointer;
        }
        
        .action-buttons {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
        }
        
        .btn {
          padding: 10px 20px;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          font-weight: bold;
          transition: all 0.3s;
        }
        
        .btn-primary {
          background: #007bff;
          color: white;
        }
        
        .btn-primary:hover {
          background: #0056b3;
        }
        
        .btn-secondary {
          background: #6c757d;
          color: white;
        }
        
        .btn-secondary:hover {
          background: #545b62;
        }
        
        .btn-danger {
          background: #dc3545;
          color: white;
        }
        
        .btn-danger:hover {
          background: #c82333;
        }
        
        .print-all-btn {
          font-size: 16px;
          padding: 12px 30px;
        }
        
        .summary {
          margin-top: 20px;
          padding-top: 20px;
          border-top: 1px solid #dee2e6;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .summary p {
          font-size: 16px;
          font-weight: bold;
          color: #28a745;
        }
        
        .attendees-list {
          margin-top: 30px;
        }
        
        .table-container {
          overflow-x: auto;
        }
        
        table {
          width: 100%;
          border-collapse: collapse;
          background: white;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        }
        
        th {
          background: #007bff;
          color: white;
          padding: 12px 15px;
          text-align: left;
          position: sticky;
          top: 0;
        }
        
        td {
          padding: 12px 15px;
          border-bottom: 1px solid #dee2e6;
        }
        
        tr:hover {
          background: #f5f5f5;
        }
        
        .attendee-name-cell {
          font-weight: bold;
          text-transform: uppercase;
        }
        
        .attendee-type-cell {
          color: #6c757d;
          font-weight: 500;
        }
        
        .btn-print {
          padding: 6px 12px;
          background: #28a745;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-size: 14px;
        }
        
        .btn-print:hover {
          background: #218838;
        }
      `}</style>
    </div>
  );
};

export default CardPrintComponent;